import _classCallCheck from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

export var createAudioDestinationNodeConstructor = function createAudioDestinationNodeConstructor(audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(AudioDestinationNode, _audioNodeConstructor);

    var _super = _createSuper(AudioDestinationNode);

    function AudioDestinationNode(context, channelCount) {
      var _this;

      _classCallCheck(this, AudioDestinationNode);

      var nativeContext = getNativeContext(context);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
      var audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
      _this = _super.call(this, context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer);
      _this._isNodeOfNativeOfflineAudioContext = isOffline;
      _this._nativeAudioDestinationNode = nativeAudioDestinationNode;
      return _this;
    }

    _createClass(AudioDestinationNode, [{
      key: "channelCount",
      get: function get() {
        return this._nativeAudioDestinationNode.channelCount;
      },
      set: function set(value) {
        // Bug #52: Chrome, Edge, Opera & Safari do not throw an exception at all.
        // Bug #54: Firefox does throw an IndexSizeError.
        if (this._isNodeOfNativeOfflineAudioContext) {
          throw createInvalidStateError();
        } // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.


        if (value > this._nativeAudioDestinationNode.maxChannelCount) {
          throw createIndexSizeError();
        }

        this._nativeAudioDestinationNode.channelCount = value;
      }
    }, {
      key: "channelCountMode",
      get: function get() {
        return this._nativeAudioDestinationNode.channelCountMode;
      },
      set: function set(value) {
        // Bug #53: No browser does throw an exception yet.
        if (this._isNodeOfNativeOfflineAudioContext) {
          throw createInvalidStateError();
        }

        this._nativeAudioDestinationNode.channelCountMode = value;
      }
    }, {
      key: "maxChannelCount",
      get: function get() {
        return this._nativeAudioDestinationNode.maxChannelCount;
      }
    }]);

    return AudioDestinationNode;
  }(audioNodeConstructor);
};